import { animate, style, transition, trigger } from '@angular/animations';
import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { CmsParagraphComponent, TranslatePipe, UserIdService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { combineLatest, Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { CookieConsentPayload, CookieConsentService } from 'src/app/service/cookie-consent/cookie-consent.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { CustomTranslationService } from 'src/app/service/language/custom-translation.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';

@Component({
  selector: 'app-cookie-consent-user',
  templateUrl: './cookie-consent-user.component.html',
  styleUrls: ['./cookie-consent-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('1s ease-out', style({ height: 300, opacity: 1 })),
      ]),
      transition(':leave', [
        style({ height: 300, opacity: 1 }),
        animate('1s ease-in', style({ height: 0, opacity: 0 })),
      ]),
    ]),
  ],
  imports: [NgClass, AsyncPipe, TranslatePipe],
})
export class CookieConsentUserComponent {
  content$: Observable<string> = this.componentData.data$.pipe(map((data) => data.content));
  showConsent = true;
  userCurrent$: Observable<string> = this.auth.getUserId();

  activeCountry$: Observable<string> = this.countryService.getActive();
  activeLanguage$: Observable<string> = this.languageService.getActive();

  isCustomTranslationsEnabled$: Observable<boolean> = combineLatest([this.activeCountry$, this.activeLanguage$]).pipe(
    switchMap(([activeCountry, activeLanguage]) =>
      this.customTranslationService.isCustomTranslationsEnabled$(activeCountry, activeLanguage, [
        'cookieConsent.title',
        'cookieConsent.continue',
      ])
    )
  );

  constructor(
    private cookieConsentService: CookieConsentService,
    private componentData: CmsComponentData<CmsParagraphComponent>,
    protected auth: UserIdService,
    private countryService: ShimanoCountryService,
    private languageService: ShimanoLanguageService,
    private customTranslationService: CustomTranslationService
  ) {}
  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }
  onCookieAccepted() {
    const payload: CookieConsentPayload = {
      userId: this.userCurrent,
    };
    this.cookieConsentService.submitCookieConsent(payload).subscribe();
    this.showConsent = false;
  }

  setCustomContext(isCustomTranslationsEnabled: boolean, activeCountry: string, activeLanguage: string) {
    return isCustomTranslationsEnabled ? [activeCountry, activeLanguage].join('-') : null;
  }
}
